import { useToast } from '../../../hooks/use-toast';

/**
 * Validates the current step of the Company Registration form.
 * Returns true if valid, or fires a toast + returns false if not.
 */
export const useCompanyRegistrationValidation = () => {
  const { toast } = useToast();

  const required = (message) => {
    toast({ title: 'Required Fields Missing', description: message, variant: 'destructive' });
    return false;
  };

  return (currentStep, formData) => {
    switch (currentStep) {
      case 1:
        if (!formData.proposedName1 || !formData.businessActivity) {
          return required('Provide at least one proposed name and business activity.');
        }
        return true;
      case 2:
        if (!formData.physicalAddress) {
          return required('Please provide the physical address.');
        }
        return true;
      case 3:
        if (formData.directors.some((d) => !d.fullName || !d.idNumber || !d.email)) {
          return required('Complete Full Name, ID Number and Email for every director.');
        }
        return true;
      case 4:
        if (formData.shareholders.some((s) => !s.fullName || !s.numberOfShares)) {
          return required('Complete Name and Number of Shares for every shareholder.');
        }
        return true;
      default:
        return true;
    }
  };
};
